module.exports = __webpack_public_path__ + "static/fipcpinkblossommain-94f4fbc25130d1908cb12e1c2fddbe03.jpeg";